module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_104919002_L-small-13867d8b3bd92f6d41c33f160d4af3ad.jpg";